// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___177ea70db1084d17a40","cls2":"AuthorHeader-cls2___fa00725d47ece5aaa55 AuthorHeader-cls1___177ea70db1084d17a40"};